import { registerLocaleData, CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID } from '@angular/core';
import localeDe from '@angular/common/locales/de';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { NavigationComponent } from './components/navigation/navigation.component';
import { FooterComponent } from './components/footer/footer.component';
import { AppRoutingModule } from './app-routing.module';
import { LoginComponent } from './components/login/login.component';
import { HomeComponent } from './components/home/home.component';

// Die zu ladenden Module
import { MainComponent } from './components/main/main.component';
import { SharedModule } from './modules/shared/shared.module';
import { JwtInterceptor } from './interceptors/jwt-interceptor';
import { AuthService } from './modules/shared/services/auth.service';
import { ErrorIntercepetor } from './interceptors/error-interceptor';
import { LoadingService } from './modules/shared/services/loading.service';
import { AuthGuard } from './guard/auth-guard';
import { LogoutComponent } from './components/logout/logout.component';
import { LoginGuard } from './guard/login-guard';
import {ServerErrorInterceptor} from './modules/shared/interceptors/server-error.interceptor';

// Registriert die Daten für die deutsche Lokalisierung
registerLocaleData(localeDe, 'de');

@NgModule({
  declarations: [
    MainComponent,
    NavigationComponent,
    FooterComponent,
    LoginComponent,
    LogoutComponent,
    HomeComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-center',
      preventDuplicates: true,
    }),
    NgbModule,
    SharedModule
  ],
  providers: [
    HttpClient,
    { provide: LOCALE_ID, useValue: 'de' },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorIntercepetor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ServerErrorInterceptor,
      multi: true
    },
    ToastrService,
    AuthService,
    LoadingService,
    AuthGuard,
    LoginGuard
  ],
  bootstrap: [MainComponent, NavigationComponent, FooterComponent],
})

export class AppModule {
  constructor() {}
}
